<template>
	<label 
	class="form-label mb-2" 
	v-bind="$attrs"
	v-html="$sanitize($slots.default)" />
</template>

<script>
	export default {
	
	}
</script>